import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Copy, ExternalLink, QrCode, Download, FileText } from "lucide-react";
import { downloadBlob } from "@/lib/workflow";

export function PublicBookingLink() {
  const [d, setD] = useState(null);
  const [qr, setQr] = useState(false);
  useEffect(() => { api.get("/booking-link").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  const copy = () => navigator.clipboard.writeText(d.url).then(() => toast.success("Link kopiert"));
  const de = (x) => x.split("-").reverse().join(".");
  return (
    <div className="bg-white border border-slate-200 rounded-xl px-4 py-3 shadow-sm mb-5" data-testid="public-booking-link">
      <div className="flex flex-wrap items-center gap-3 justify-between">
        <div className="min-w-0">
          <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">Öffentlicher Buchungslink für Interessenten</div>
          <div className="text-sm font-mono text-slate-800 truncate" data-testid="public-booking-url">{d.url}</div>
          <div className="text-xs text-slate-500 mt-0.5" data-testid="public-booking-status">{d.issue ? <>Buchbar: <b>{d.issue}</b> bis {de(d.deadline)} (Buchungsschluss laut Zeitplan)</> : "Derzeit keine Ausgabe buchbar – die Seite zeigt „Buchung derzeit nicht möglich“."}</div>
        </div>
        <div className="flex flex-wrap gap-2 shrink-0">
          <Button size="sm" variant="outline" onClick={copy} data-testid="public-booking-copy"><Copy size={14} className="mr-1.5" /> Kopieren</Button>
          <Button size="sm" variant="outline" onClick={() => window.open(d.url, "_blank")} data-testid="public-booking-open"><ExternalLink size={14} className="mr-1.5" /> Öffnen</Button>
          <Button size="sm" variant="outline" onClick={() => setQr((v) => !v)} data-testid="public-booking-qr-toggle"><QrCode size={14} className="mr-1.5" /> QR-Code</Button>
          <Button size="sm" variant="outline" onClick={() => downloadBlob("/mediadaten.pdf", {}, "Mediadaten.pdf")} data-testid="public-booking-mediadaten"><FileText size={14} className="mr-1.5" /> Mediadaten (PDF)</Button>
        </div>
      </div>
      {qr && (
        <div className="mt-3 flex items-center gap-4" data-testid="public-booking-qr">
          <img src={d.qr} alt="QR-Code Buchungslink" className="h-36 w-36 border border-slate-200 rounded" />
          <a href={d.qr} download="QR-Anzeige-buchen.png" className="text-sm text-blue-600 hover:underline inline-flex items-center gap-1" data-testid="public-booking-qr-download"><Download size={14} /> Als PNG herunterladen</a>
        </div>
      )}
    </div>
  );
}
